// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.attributeTypeMap = [
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "number"
    },
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "payorType",
        "baseName": "payorType",
        "type": "PayorType"
    },
    {
        "name": "payorBin",
        "baseName": "payorBin",
        "type": "string"
    },
    {
        "name": "payorPcn",
        "baseName": "payorPcn",
        "type": "string"
    },
    {
        "name": "payorGroup",
        "baseName": "payorGroup",
        "type": "string"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    },
    {
        "name": "accountRoleType",
        "baseName": "accountRoleType",
        "type": "RoleType"
    },
    {
        "name": "accountRelationshipCoverageOrder",
        "baseName": "accountRelationshipCoverageOrder",
        "type": "number"
    },
    {
        "name": "accountRelationshipIsPrimary",
        "baseName": "accountRelationshipIsPrimary",
        "type": "boolean"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": ""
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": ""
    },
    {
        "name": "payorBenefit",
        "baseName": "payorBenefit",
        "type": "EnterpriseCoordinatorPayorServiceModelsPayorBenefitModel"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPayorServiceModelsPayorUpsearchModel.js.map